import SiteHeader from './header';
import { retailerApi } from '@common/retailer-api';
export const HeaderContainer = ({
  hasMenu,
  onToggleMenu
}) => {
  const {
    data: profile,
    error,
    isFetching
  } = retailerApi.useGetUserProfileQuery();
  const userName = profile?.user?.name || null;
  const userRole = profile?.user?.role || null;
  const hasError = Boolean(error);
  return <SiteHeader hasError={hasError} hasMenu={hasMenu} isLoading={isFetching} onToggleMenu={onToggleMenu} username={userName} userRole={userRole} />;
};